<template>
  <div id="purecloud-chat">
  </div>
</template>

<script>
export default {
  name: "PureCloudChat",
  props: {
    userDetails: {
      type: Object
    }
  },
  data: () => ({}),
  methods: {},
  mounted: function() {
    const chatConfig = {
      // Web chat application URL
      webchatAppUrl: "https://apps.mypurecloud.com.au/webchat",

      // Web chat service URL
      webchatServiceUrl: "https://realtime.mypurecloud.com.au:443",

      // Numeric organization ID
      orgId: 9985,

      // Organization name. Replace with your org name.
      orgName: "n7005695rcancercouncilqld",

      // Requested agent language skill (Agent must have this language skill to receive chat)
      // language: 'English - Written',

      // Requested agent skills (Agent must have these skills to receive chat)
      skills: [],
      // OR
      //skills: [],

      // Priority
      priority: 5,

      // Queue Name
      queueName: "13 11 20 Webchat",

      // Target agent email (OPTIONAL)
      // agentEmail: '',

      // Whether to show submit button or send message on Enter keypress
      showSubmitButton: true,

      // Log level
      logLevel: "DEBUG",

      // Locale code
      locale: "en",

      // Whether to allow reconnects
      reconnectEnabled: true,

      //Allowed reconnect origins
      reconnectOrigins: [
        "https://cancerqld.org.au"
      ],

      // Logo used within the chat window
      companyLogoSmall: {
        width: 149,
        height: 78,
        url:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Solid_white.svg/2000px-Solid_white.svg.png"
      },
      // Fallback image used for agent if no agent image is defined in the agent's PureCloud profile
      agentAvatar: {
        width: 462,
        height: 462,
        url:
          "https://dhqbrvplips7x.cloudfront.net/webchat/1.0.23/agent-e202505f.png"
      },

      // Text displayed with chat window is displayed
      welcomeMessage:
        "Thank you for contacting Cancer Council Queensland. Please wait while we connect you with a Cancer Support Advisor...",

      // CSS class applied to the chat window
      cssClass: "webchat-frame",

      // Custom style applied to the chat window
      css: {
        width: "100%",
        height: "100%"
      },

      offlineSchedules: [
        {
          day: "Monday-Sunday",
          time: "1400-2359",
          city: "Australia/Brisbane"
        },

        {
          day: "Monday-Sunday",
          time: "0000-0959",
          city: "Australia/Brisbane"
        },

        {
          date: 25, // Christmas
          month: 12,
          year: 2018,
          city: "Australia/Brisbane"
        }
      ],

      // Element that will have 'purecloud-chat-available' class added to it when
      // intersection of online and not offline schedules
      chatNowElement: "chat-button"
    };

    window.PURECLOUD_WEBCHAT_FRAME_CONFIG = {
      containerEl: "purecloud-chat"
    };

    window.ININ.webchat.create(chatConfig)
        .then((webchat) => {
          let { firstName, lastName, email } = this.userDetails;
          webchat.getConfig().setData({ firstName, lastName, email });
          // webchat.updateConfig({
          //   welcomeMessage: "Waiting for a Cancer Council Queensland Coordinator..."
          // })
          webchat.renderFrame( { containerEl: 'purecloud-chat' });
          // webchat.chatStarted = () => {           this.$ga.event('chat', 'chat started'); }
          // webchat.chatConnectedToAgent = () => {  this.$ga.event('chat', 'chat connected to agent'); }
          // webchat.chatEnded = () => {             this.$ga.event('chat', 'chat ended'); }
        })
        .catch((err) => {
          // this.$ga.event('chat', 'error loading webchat');
          console.error(`Error connecting to chat - ${err}`);
        });
  }
};
</script>

<style scoped lang="scss">
@use "./_responsive.scss" as *;

div#purecloud-chat {
    position: absolute;
    top: 0px;
    left: 150px;
    width: calc(100% - 150px);
    height: 100%;

    @include tablet {
      left: 0;
      width: 100%;
      top: 100px;
      height: calc(100% - 100px);
    }
}
</style>
